/* eslint-disable react/forbid-foreign-prop-types */
import PropTypes from 'prop-types';
import LayoutProps from './layout';
import WidthProp from '../width';

const propTypes = {
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  verticalAlignment: PropTypes.oneOf(['start', 'end', 'center', 'spread']),
  horizontalAlignment: PropTypes.oneOf(['start', 'end', 'center', 'spread']),
  spaceChildren: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontal', 'vertical'])]),
  spaceChildrenWithin: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontal', 'vertical'])]),
  children: PropTypes.node,
  childrenWidth: WidthProp,
  ...LayoutProps.propTypes
};

const defaultProps = {
  ...LayoutProps.defaultProps,
  orientation: 'horizontal',
  verticalAlignment: 'start',
  horizontalAlignment: 'start',
  spaceChildren: false,
  spaceChildrenWithin: false,
  width: 12
};

const propDescriptions = {
  ...LayoutProps.propDescriptions,
  orientation:
    'Defines how child components will be laid out ~ if horizontal children will be laid out one beside the other, if vertical children will be laid out one under the other #layout',
  verticalAlignment: 'Defines how children are aligned on the vertical axis #layout',
  horizontalAlignment: 'Defines how children are aligned on the horizontal axis #layout',
  spaceChildren: 'Applies default margin spacing to each of its children #layout',
  spaceChildrenWithin: 'Applies default padding to each of its children #layout',
  children: 'Child components #layout',
  childrenWidth: 'Applies default width to each of its children #layout'
};

const containerProps = {
  propTypes,
  defaultProps,
  propDescriptions
};

export default containerProps;
